/* rz.js — move gallery between Price and Size on mobile only */
(function () {
  const MQ = '(max-width: 699px)';

  function setupProduct(productRoot) {
    if (!productRoot || productRoot.__rzInit) return;
    const gallery = productRoot.querySelector('product-gallery.product-gallery');
    const info    = productRoot.querySelector('safe-sticky.product-info');
    const price   = info && info.querySelector('.product-info__block-item[data-block-type="inventory"]');
    if (!gallery || !info || !price) return;

    // Mark as initialized per product root
    productRoot.__rzInit = true;

    // Create a marker to restore original gallery position on desktop
    const marker = document.createComment('rz-gallery-marker');
    if (!gallery.previousSibling || gallery.previousSibling !== marker) {
      gallery.parentNode.insertBefore(marker, gallery);
    }

    // Media query listener
    const mql = window.matchMedia(MQ);

    function place() {
      if (mql.matches) {
        // MOBILE: put gallery right after Price block
        if (gallery.parentNode !== info || price.nextElementSibling !== gallery) {
          price.insertAdjacentElement('afterend', gallery);
        }
        gallery.style.width = '100%';
        gallery.style.margin = '8px 0 12px';
      } else {
        // DESKTOP: restore to original location using marker
        if (marker.parentNode && gallery.parentNode !== marker.parentNode) {
          marker.parentNode.insertBefore(gallery, marker.nextSibling);
        } else if (marker.parentNode && marker.nextSibling !== gallery) {
          marker.parentNode.insertBefore(gallery, marker.nextSibling);
        }
        gallery.style.width = '';
        gallery.style.margin = '';
      }
    }

    // Initial placement + listeners
    place();
    if (mql.addEventListener) {
      mql.addEventListener('change', place);
    } else {
      // Safari <14 fallback
      mql.addListener && mql.addListener(place);
      window.addEventListener('resize', place);
    }

    // Re-run when Shopify dynamically reloads sections (quick view / variant refresh)
    document.addEventListener('shopify:section:load', function (e) {
      if (productRoot.contains(e.target)) place();
    });
    document.addEventListener('shopify:section:select', function (e) {
      if (productRoot.contains(e.target)) place();
    });
  }

  function init(ctx) {
    (ctx || document).querySelectorAll('.product').forEach(setupProduct);
  }

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ init(document); });
  } else {
    init(document);
  }
})();

/* rz.js — Floating Add to cart on mobile */
(function () {
  const MQ = '(max-width: 699px)';

  function initFloatingATC(productRoot) {
    if (!productRoot || productRoot.__rzATCInit) return;

    const form = productRoot.querySelector('form.shopify-product-form');
    const buyButtons = productRoot.querySelector('buy-buttons, .buy-buttons');
    const nativeATC = buyButtons && buyButtons.querySelector('button[type="submit"].button');

    if (!form || !nativeATC) return;
    productRoot.__rzATCInit = true;

    // Create bar
    const bar = document.createElement('div');
    bar.className = 'rz-atc-bar';
    bar.innerHTML = `
      <button type="button" class="button rz-atc-btn">Add to cart</button>
    `;
    const barBtn = bar.querySelector('.rz-atc-btn');

    // Sync label / color from native button (optional)
    barBtn.textContent = nativeATC.textContent.trim() || 'Add to cart';
    // Copy CSS variables for color if present
    const cs = getComputedStyle(nativeATC);
    ['--button-background','--button-outline-color','--button-border',
     '--button-text','--button-radius'].forEach(v=>{
      const val = cs.getPropertyValue(v);
      if (val) barBtn.style.setProperty(v, val);
    });

    // Submit the real form on click
    barBtn.addEventListener('click', () => {
      if (barBtn.disabled) return;
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });

    // Keep disabled state in sync (sold out, invalid, etc.)
    const syncDisabled = () => {
      const disabled = nativeATC.hasAttribute('disabled') || nativeATC.disabled;
      barBtn.disabled = !!disabled;
    };
    syncDisabled();

    const mo = new MutationObserver(syncDisabled);
    mo.observe(nativeATC, { attributes: true, attributeFilter: ['disabled', 'class'] });

    // Mount/unmount by media query
    const mql = window.matchMedia(MQ);

    function measureAndPad() {
      // set body padding so content isn’t covered
      document.body.classList.add('rz-atc-padding');
      document.body.style.setProperty('--rz-atc-height', (bar.offsetHeight + 4) + 'px');
    }

    function place() {
      if (mql.matches) {
        if (!document.body.contains(bar)) {
          document.body.appendChild(bar);
          // next frame measure for accurate height
          requestAnimationFrame(measureAndPad);
        } else {
          measureAndPad();
        }
      } else {
        if (document.body.contains(bar)) {
          bar.remove();
          document.body.classList.remove('rz-atc-padding');
          document.body.style.removeProperty('--rz-atc-height');
        }
      }
    }

    place();
    if (mql.addEventListener) mql.addEventListener('change', place);
    else mql.addListener && mql.addListener(place);

    // Re-measure on resize (keyboard open/close, orientation)
    window.addEventListener('resize', () => {
      if (document.body.contains(bar)) measureAndPad();
    });

    // If your theme swaps variants dynamically, resync the state
    document.addEventListener('shopify:section:load', (e) => {
      if (productRoot.contains(e.target)) syncDisabled();
    });
    document.addEventListener('change', (e) => {
      if (productRoot.contains(e.target)) syncDisabled();
    });
  }

  function boot(ctx) {
    (ctx || document).querySelectorAll('.product').forEach(initFloatingATC);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document));
  } else {
    boot(document);
  }
})();




/* rz.js — Mirror Selly discounted price to top price (robust jQuery) */
(function initLoader () {
  function boot($) {
    $(function () {
      var $doc = $(document);

      $('.product').each(function () {
        var $root = $(this);
        var $form = $root.find('form.shopify-product-form').first();
        if (!$form.length) return;

        // 1) TOP price container (try a few patterns)
        function getTopPriceList() {
          // most themes
          var $p = $root.find('.product-info__block-item[data-block-type="price"] .price-list').first();
          if ($p.length) return $p;

          // fallback: any <price-list> in the price block
          $p = $root.find('.product-info__block-item[data-block-type="price"] price-list').first();
          if ($p.length) return $p;

          // ultimate fallback
          return $root.find('.price-list').first();
        }

        // 2) Current variant id
        function getVariantId() {
          var v = $form.find('input[name="id"]').first().val();
          return v ? String(v) : '';
        }

        // 3) Read Selly’s **discount widget** price for that variant (preferred)
        function readSellyDiscountWidget(variantId) {
          // widget can be outside .product → search document
          var $saleMoney = $('#tdf_sale_widget .tdf_discount_content .tdf_price_sales[data-vp="'+variantId+'"] .money').first();
          if (!$saleMoney.length) return null;

          var $content = $saleMoney.closest('.tdf_discount_content');
          var $origMoney = $content.find('.tdf_price_original .money').first();

          return {
            saleHTML: $saleMoney.html().trim(),
            origHTML: $origMoney.length ? $origMoney.html().trim() : ''
          };
        }

        // 4) Fallback: read Selly **per-item tile** price in the bundle list (NOT the total)
        function readSellyBundleTile(variantId) {
          var $tileMoney = $('.tdf_bundle_content .tdf_vertical_price[data-vp="'+variantId+'"] .money').first();
          if (!$tileMoney.length) return null;
          return {
            saleHTML: $tileMoney.html().trim(),
            origHTML: '' // tile usually doesn’t show original; we’ll skip it
          };
        }

        // 5) Render into top price
        function render() {
          var $topPrice = getTopPriceList();
          if (!$topPrice.length) return;

          var vid = getVariantId();
          if (!vid) return;

          // prefer discount widget, then tile
          var data = readSellyDiscountWidget(vid) || readSellyBundleTile(vid);
          if (!data) return; // no Selly price for this variant → leave theme price alone

          var html = '';
          if (data.saleHTML) html += '<span class="money rz-price--sale">'+ data.saleHTML +'</span>';
          html += '<span class="money rz-price--orig">'+ data.origHTML +'</span> ';

          if ($topPrice.attr('data-rz-price-html') === html) return; // no infinite loop
          $topPrice.attr('data-rz-price-html', html).html(html);
        }

        // Debounced scheduler
        var rafId = null;
        function schedule() {
          if (rafId) return;
          rafId = requestAnimationFrame(function(){ rafId = null; render(); });
        }

        // Initial try (keeps Shopify price until Selly loads)
        schedule();

        // Re-render when variant id changes
        $root.on('change', 'select, input[name="id"], input[type="radio"]', schedule);

        // Watch the hidden variant input value (some themes update it silently)
        var idInput = $form.find('input[name="id"]').get(0);
        if (idInput && window.MutationObserver) {
          new MutationObserver(schedule).observe(idInput, { attributes: true, attributeFilter: ['value'] });
        }

        // Observe Selly areas for async updates
        ['#tdf_sale_widget', '.tdf_bundle_content'].forEach(function(sel){
          var el = document.querySelector(sel);
          if (el && window.MutationObserver) {
            new MutationObserver(schedule).observe(el, { childList: true, subtree: true, characterData: true });
          }
        });

        // Shopify section reloads / quick view etc.
        $doc.on('shopify:section:load shopify:section:select', schedule);

        // Safety: also re-check after a short delay for late widgets
        setTimeout(schedule, 800);
        setTimeout(schedule, 2000);
      });
    });
  }

  // Use existing jQuery or load it
  if (window.jQuery) {
    boot(window.jQuery);
  } else {
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/jquery@3.7.1/dist/jquery.min.js';
    s.async = true;
    s.onload = function(){ boot(window.jQuery); };
    document.head.appendChild(s);
  }
})();